import React from 'react';
import pediatraImage from '../../assets/images/servicos/pediatra.jpg';

const Pediatra = () => {
    return (
        <>
            <section className="breadcrumb-section">
                <div className="container">
                    <h1>Pediatra</h1>
                    <div className="breadcrumb">
                        <a href="/home">Home</a>
                        <span className="fa fa-angle-double-right"></span>
                        <span className="current">Pediatra</span>
                    </div>
                </div>
            </section>

            <div id="main">
                <div className="container">
                    <section id="primary" className="with-sidebar">
                        <article className="blog-entry">
                            <div className="blog-entry-inner">
                                <div className="entry-thumb">
                                    <img src={pediatraImage} alt="Pediatra" />
                                </div>
                                <div className="entry-details">
                                    <div className="entry-title">
                                        <h3> Qual a importância do acompanhamento com a pediatra? </h3>
                                    </div><br />
                                    <div className="entry-body">
                                        <p>Médica Pediatra é a responsável por cuidar da saúde das crianças e dos adolescentes.</p><br />
                                        <p>Além de orientar as famílias sobre alimentação, vacinação, aleitamento, desenvolvimento infantil, etc. São responsáveis por diagnosticar, tratar e prevenir.</p><br />
                                        <p>As consultas regulares com um pediatra são importantes para o desenvolvimento da criança e para reduzir a probabilidade de problemas de saúde. A frequência das visitas deve ser adequada à faixa etária da criança.</p>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </section>

                    <section id="secondary">
                        <aside className="widget widget_text">
                            <h3 className="widgettitle">Nossos serviços incluem</h3>
                            <p><b>Consulta:</b><br /> Presencial</p><br />
                            <p><b>Consulta:</b><br /> On-line</p><br />
                        </aside>
                    </section>
                </div>
            </div>
        </>
    );
};

export default Pediatra;
